var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Tady bude zobrazena aplikace MojaMapa...jste na dev verzi, ta aplikaci nepodporuje.")]),_c('router-link',{staticStyle:{"font-size":"50px"},attrs:{"to":_vm.localeRoute('home')}},[_vm._v("HOME Link")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }